import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrganizationForecastRateApiService } from '@_services/api/organization-forecast-rate-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedOrganizationForecastRateEffects } from './organization-forecast-rate-generated.effects';

@Injectable()
export class OrganizationForecastRateEffects extends GeneratedOrganizationForecastRateEffects {
  constructor(
    actions$: Actions,
    organizationForecastRateApiService: OrganizationForecastRateApiService,
    store$: Store<AppState>
  ) {
    super(actions$, organizationForecastRateApiService, store$);
  }
}
